import React from 'react'
import '../App.css'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'
import LoginMagic from './LoginMagic'
import Open from './Open'
import RedirectToApp from './RedirectToApp'
import UploadPhoto from './UploadPhoto'

const App = () => (
    <Router>
        <Switch>
            <Route path="/login_magic" component={LoginMagic} />
            <Route path="/upload_photo" component={UploadPhoto} />
            <Route path="/open/profile/:projectionId/:personId" component={Open} />
            <Route component={RedirectToApp} />
        </Switch>
    </Router>
)

export default App
